export default {
    inheritAttrs: false,
    props: {
        initials: {
            required: true,
            type: String,
        },
    },
}
